export enum ProfileSelectorFieldEnum {
  ProfileID = 0,
  ProfileName = 1,
  OrgIndicator = 2,
  Member = 3,
  ProfileStatus = 4,
  AssignedTo = 5,
  SoldBy = 6,
  Prospect = 7,
  Prefix = 8,
  FirstName = 9,
  MI = 10,
  LastName = 11,
  Suffix = 12,
  Title = 13,
  ReportName = 14,
  WorkPhone = 15,
  HomeTollFreePhone = 16,
  Email = 17,
  Fax = 18,
  Address1 = 19,
  Address2 = 20,
  City = 21,
  StateProv = 22,
  ZipPostalCode = 23,
  County = 24,
  Country = 25,
  Website = 26,
  EmployeesFT = 27,
  EmployeesPT = 28,
  Inactive = 35,
  Customers = 36,
  MainProfileName = 37,
  MainProfileWorkPhone = 38,
  MainProfileHomePhone = 39,
  MainProfileEmail = 40,
  MainProfilePrefix = 42,
  MainProfileFirstName = 43,
  MainProfileMI = 44,
  MainProfileLastName = 45,
  MainProfileSuffix = 46,
  AnnualDues = 47,
  MembershipLevel = 48,
  MemberSince = 49,
  MobilePhone = 50,
  Ext = 51,
  Units = 52,
  ProfileType = 53,
  ManagementCompany = 54,
  Owner = 55,
  Role = 56,
  PrimaryCategory = 57,
  ListingLevel = 58,
  DetailListingLevel = 59,
  ExternalID = 60,
  Gender = 61,
  PreferredPaymentMethod = 62,
  PreferredBillingMethod = 63,
  RelatedOrganization = 64,
  ReceivesCommunication = 65,
  NonDuesBillings = 66,
  DuesDatePaid = 67,
  DuesAnchorMonth = 68,
  SumofAmountDue = 69,
  LastEventAttended = 70,
  LastEventSignedUpfor = 71,
  EventsPast12Months = 72,
  ReferralsPast12Months = 73,
  LastLoginDate = 74,
  LastContactDate = 75,
  LastContactType = 76,
  ContactsPast12Months = 77,
  MainContact = 78,
  Dba = 79,
  NoEmail = 80,
}
